import React, { useState, useCallback } from 'react';
import '../../styles/mainContents.css';
import { setReturnsState, fetchValidatePartno } from '../../redux/actions/PostActions';
import { connect } from 'react-redux';
import Select from 'react-select';
import AsyncCreatableSelect from 'react-select/async-creatable';

function ReturnsTable(props) {
                           
  const { returnsPartnoValidState, dispatchValidatePartNumber, returnsPartnoListState, 
          custid, custloc, 
          returnsState, dispatchSetReturnsState } = props; 

  let currState = [...returnsState];
  
  const filterSearch = (inputValue) => {

    //console.log('filterSearch ', returnsPartnoListState.filter((i) => i.label.toUpperCase().includes(inputValue.toUpperCase())).toUpperCase())
    return returnsPartnoListState.filter((i) => 
      i.label.toUpperCase().includes(inputValue.toUpperCase())
    )
  };

  const promiseOptions = (inputValue) => {
      return new Promise( resolve => {

        resolve(filterSearch(inputValue))

        // setTimeout(() => {
        //   resolve(filterSearch(inputValue));
        // }, 1000);
      })
  };

  const handleCreateOption = async (inputValue,) => {
    // // setInputError(null); // Clear previous errors

    console.log('handleCreateOption inputValue called')
    inputValue = inputValue.toUpperCase()

    // // Dispatch action to validate the part number via API
    // const validationResult = await dispatch(validatePartNumber(inputValue));
    await dispatchValidatePartNumber(inputValue)
  };

  let handleOnChange = (state,v,i,e) => {
    let currentValue = e.value
    console.log('ReturnsTable pt currentValue', currentValue, 'i', i, 'lastRowPartnoValue', currentValue)

    if (currentValue !==  '') {     
      
      let maxPartnoLength = 53
      if(currentValue.length > maxPartnoLength){
        e.target.value = currentValue.substring(0,maxPartnoLength)
        console.log('ReturnsTable: Partno length is invalid. Had entered ', currentValue.length, ' characters')
        alert('Partno length is invalid. Please check partno.')
      }
      else{
        try{                              
          let updatedReturnsState = state.map((item, index) => {
            if (index === i) {
              return {
                ID: v['ID'] === undefined ? 'returns' + 0 : v['ID'], 
                PARTNO: currentValue,
                QTY:'',
                ITEMCOST:'',
                CUSTID: custid,                          
              };
            }
            return item;                                        
          });
      
          let returnsNewItemState = null;
          if(!(i in state) || (i === state.length - 1) ){
            returnsNewItemState = {ID: 'returns' + Math.floor(Math.random()*50000), PARTNO: '', QTY:'', ITEMCOST:'', 
                CUSTID: custid,                 
              }
          }

          let newState = [...updatedReturnsState]
          if(returnsNewItemState !== null){
            newState = [...updatedReturnsState, returnsNewItemState]
          }
          dispatchSetReturnsState(newState);                        

        }
        catch(ex){
          console.log('ERROR ReturnsTable fetch_validateReturnsPartno failed : ' + ex)
          alert('Unable to confirm partno. Please check and try again.')
        }
      }                        
    } 

  }

  let ReturnsTr = (state) => {
    
    return state.map(function(v, i){

      let keyId = ((state[i]['ID'] === undefined) ? 'returns' + 0 :  v['ID'])

      //TODO after entering new partno; save partno in returnState or call onChange
      return (
        <tr key={'returnsTr-'+ keyId}>
          <td>            
            <AsyncCreatableSelect menuPosition="fixed" menuPlacement="top" 
              defaultOptions={returnsPartnoListState}
              loadOptions={ promiseOptions } 
              onCreateOption={ handleCreateOption }
              onChange={ e => {
                let currentValue = e.value
                console.log('ReturnsTable pt currentValue', currentValue, 'i', i, 'lastRowPartnoValue', currentValue)

                if (currentValue !==  '') {     
                  
                  let maxPartnoLength = 53
                  if(currentValue.length > maxPartnoLength){
                    e.target.value = currentValue.substring(0,maxPartnoLength)
                    console.log('ReturnsTable: Partno length is invalid. Had entered ', currentValue.length, ' characters')
                    alert('Partno length is invalid. Please check partno.')
                  }
                  else{
                    try{                              
                      let updatedReturnsState = state.map((item, index) => {
                        if (index === i) {
                          let qty = item['QTY'] === undefined ? '' : item['QTY']
                          let itemCost = item['ITEMCOST'] === undefined ? '' : item['ITEMCOST']

                          return {
                            ID: v['ID'] === undefined ? 'returns' + 0 : v['ID'], 
                            PARTNO: currentValue,
                            QTY: qty,
                            ITEMCOST: itemCost,
                            CUSTID: custid,                                                     
                          };
                        }
                        return item;                                        
                      });
                  
                      let returnsNewItemState = null;
                      if(!(i in state) || (i === state.length - 1) ){
                        returnsNewItemState = {ID: 'returns' + Math.floor(Math.random()*50000), PARTNO: '', QTY:'', ITEMCOST:'', 
                          CUSTID: custid,                    
                        }
                      }
            
                      let newState = [...updatedReturnsState]
                      if(returnsNewItemState !== null){
                        newState = [...updatedReturnsState, returnsNewItemState]
                      }
                      dispatchSetReturnsState(newState);                        
            
                    }
                    catch(ex){
                      console.log('ERROR ReturnsTable fetch_validateReturnsPartno failed : ' + ex)
                      alert('Unable to confirm partno. Please check and try again.')
                    }
                  }                        
                }                 
              }}              
            />
          </td>   

          <td>
            <input 
              id={'iReturnsQty-' + keyId }
              className={'userInputField'}
              type='number' 
              name='nReturnsQty'
              min="0"
              max="100" 
              onBlur={(e) => {         
                if(e.target.value.trim() < 0){
                  alert('cannot have qty less than 0');
                  e.target.value = 0;

                  return;
                }   
                else if (e.target.value.trim() > 100){
                  alert('cannot have qty more than 100');
                  e.target.value = 0;

                  return;
                }             

                const updatedReturnsState = state.map((item, index) => {
                  if (index === i) {
                    return {
                      ...item,
                      QTY: e.target.value.trim(),
                    };
                  }
                  return item;
                });
                dispatchSetReturnsState(updatedReturnsState);

              }
              }
            />                      
          </td>     

          <td>
            <input 
              id={'iReturnsItemCost-' + keyId }
              className={'userInputField'}
              type='number' 
              name='nReturnsItemCost'      
              onBlur={(e) => {                  
                let itemCostValue = e.target.value.trim().replace(/[eE]/g, '')                   
                const updatedReturnsState = state.map((item, index) => {
                  if (index === i) {
                    return {
                      ...item,
                      ITEMCOST: itemCostValue,
                    };
                  }
                  return item;
                });
                dispatchSetReturnsState(updatedReturnsState);

              }
              }
            />                      
          </td>

          <td>
            <input 
              id={'iReturnsDeleteRow-' + keyId }
              className={'userInputField'}
              type='button' 
              name='nReturnsDeleteRow' 
              defaultValue={'X'}     
                          
              onClick={(e) => {
                console.log('iReturnsDeleteRow delete row clicked index:', i)

                if(state.length > 1){
                  //delete row
                  console.log('ReturnsTable delete row returnsState WAS', state, 'i',i)    

                  const updatedReturnsState = state.filter((item, index) => index !== i);

                  console.log('ReturnsTable delete row updatedReturnsState', updatedReturnsState, 'i',i)    

                  dispatchSetReturnsState(updatedReturnsState);                        
                }
                else {
                  const updatedReturnsState = state.map((item, index) => {
                    if (index === i) {
                      return {
                        ID: 'returns' + Math.floor(Math.random()*50000),
                        PRDID: '',
                        QTY: '',
                        ITEMCOST: '',
                        CUSTID: custid,                      
                      };
                    }
                    return item;
                  });
                  console.log('ReturnsTable delete row 0 updatedReturnsState', updatedReturnsState, 'i',i)    

                  dispatchSetReturnsState(updatedReturnsState);
                }
              }
              }
            />                      
          </td>

                                                             
        </tr>    
          
      )
    });

  
  }

  return (

    <div>

      <table id='returnsTblId' key='returnsTblKey'>
        <thead>
          <tr key='returnsTblHeader'>  
            <th style={ {minWidth:'180px'}} >Partno</th>
            <th>Qty</th>
            <th>Item Cost</th>
            <th></th>
          </tr>
        </thead>
        { 
          <tbody id='returnsDataTable_body' key='returnsDataTable_bodyKey'>
           {ReturnsTr(currState)}

          </tbody>
        }

      </table>
    </div>

  );
}



const mapStateToProps = (state) => {
 return {
  authreducerState: state.authreducer,
  returnsState: state.returnsReducer['items_returnsState'],
  returnsPartnoListState: state.returnsReducer['items_returnsPartnoList'],  
  returnsPartnoValidState: state.returnsReducer['partnoIsValid'],
 }
};

const mapDispatchToProps = (dispatch) => {
  return {      
    dispatchSetReturnsState: (returnsData) => {
      dispatch(setReturnsState(returnsData));
    },
    dispatchValidatePartNumber: (partnoInputValue) => {
      dispatch(fetchValidatePartno(partnoInputValue));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnsTable);